// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const MinusIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="MinusIcon" ref={forwardedRef} {...props}>
      <path d="M16 10.75H4v-1.5h12z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const MinusIcon = /* @__PURE__ */ Object.assign(MinusIconComponent, {
  displayName: 'MinusIcon',
});
